import InterfaceUserMultiple from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/user/interface-user-multiple.svg';
import InterfaceUserSingle from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/user/interface-user-single.svg';
import styled from 'styled-components';
import { AccessSubjectType } from '../../../../../../common/iam/access/types';
import { ModelEntityType } from '../../../../../../common/model/input/types';
import { BouSvgIcon } from '../../../../generic/components/bou-svg-icon';
import { getModelEntityStreamlineIcon } from '../../../../generic/global/model-entity-icons';

const IconWrap = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 19px;
  height: 12px;
  font-size: 12px;
`;

export function getOptionIcon(type: ModelEntityType | AccessSubjectType, created?: boolean): JSX.Element | undefined {
  if (created) {
    return;
  }
  switch (type) {
    case ModelEntityType.COMPANY:
    case ModelEntityType.PRODUCT:
    case ModelEntityType.MIXIN:
    case ModelEntityType.PHENOMENON:
    case ModelEntityType.GROUP:
    case ModelEntityType.PORTFOLIO:
      return (
        <IconWrap>
          <BouSvgIcon icon={getModelEntityStreamlineIcon(type)} />
        </IconWrap>
      );
    case AccessSubjectType.USER:
      return (
        <IconWrap>
          <BouSvgIcon icon={<InterfaceUserSingle />} />
        </IconWrap>
      );
    case AccessSubjectType.USER_GROUP:
      return (
        <IconWrap>
          <BouSvgIcon icon={<InterfaceUserMultiple />} />
        </IconWrap>
      );
  }

  return undefined;
}
